import Menu1 from "./components/Menu1.js";
import MenuOverlayToggler from "./components/MenuOverlayToggler.js";

import IntersectionObserverAnimations from "./components/IntersectionObserverAnimations.js";
import ScrollHandler from "./components/ScrollHandler.js";

import CoverVideo from "./components/core-blocks/CoverVideo.js";
import MediaTextVideo from "./components/core-blocks/MediaTextVideo.js";
import Video from "./components/core-blocks/Video.js";
import VimeoEmbed from "./components/core-blocks/VimeoEmbed.js";
import YouTubeEmbed from "./components/core-blocks/YouTubeEmbed.js";
import CoverScrollDownButton from "./components/core-blocks/CoverScrollDownButton.js";

import LogoSlideshow from "./components/acf-blocks/LogoSlideshow.js";
import Slideshow from "./components/acf-blocks/Slideshow.js";
import Counters from "./components/acf-blocks/Counters.js";
import Documents from "./components/acf-blocks/Documents.js";

import SectionScrolling from "./components/SectionScrolling.js";
import MenuOverlay from "./components/MenuOverlay.js";


//
// Manage vh unit
const setAppHeights = () => {
	const vh = window.innerHeight * .01;
	document.documentElement.style.setProperty('--vh', `${vh/10}rem`);
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight/10}rem`);
};
window.addEventListener('resize', setAppHeights)
setAppHeights();

//
// Enable event listener for pushState
const _wr = (type) => {
	const orig = history[type];
	return function() {
		const rv = orig.apply(this, arguments);
		const e = new Event(type);
		e.arguments = arguments;
		window.dispatchEvent(e);
		return rv;
	};
};
history.pushState = _wr('pushState');
history.replaceState = _wr('replaceState');

//
// Blocks
document.querySelectorAll('.wp-block-cover-wrapper.has-video').forEach(block => new CoverVideo(block));
document.querySelectorAll('.wp-block-media-text-wrapper.has-video').forEach(block => new MediaTextVideo(block));
document.querySelectorAll('.wp-block-embed-vimeo').forEach(block => new VimeoEmbed(block));
document.querySelectorAll('.wp-block-embed-youtube').forEach(block => new YouTubeEmbed(block));
document.querySelectorAll('.wp-block-video-wrapper').forEach(domEl => new Video(domEl));
document.querySelectorAll('.wp-block-cover-wrapper').forEach((domEl) => {
	if(domEl.querySelector('.scroll-down-button')) {
		new CoverScrollDownButton(domEl); // :has selector is not supported in Firefox
	}
});
//document.querySelectorAll('.wp-block-cover-wrapper:has(.scroll-down-button)').forEach(domEl => new CoverScrollDownButton(domEl));

document.querySelectorAll('.acf-block-logo-slideshow').forEach(domEl => new LogoSlideshow(domEl));
document.querySelectorAll('.acf-block-slideshow').forEach(domEl => new Slideshow(domEl));
document.querySelectorAll('.acf-block-counters').forEach(domEl => new Counters(domEl));
document.querySelectorAll('.acf-block-documents').forEach(domEl => new Documents(domEl));

//
// Menus
new Menu1();
new MenuOverlayToggler();
new MenuOverlay();

//
// Animations
new IntersectionObserverAnimations();
new ScrollHandler();
if(document.body.classList.contains('has-section-scrolling-enabled')) {
	new SectionScrolling();
}